import { useLazyGetCpxHpInfosQuery, useSelectCPxCardMutation } from '@/core/services/dmp-connect-js2'
import { CardReader, GetCpxHpInfosResponse } from '@/core/types/dmp-connect'
import { useCallback, useState } from 'react'

export function useGetCPxCardsInfos() {
  const [getCpxHpInfos] = useLazyGetCpxHpInfosQuery()
  const [selectCPxCard] = useSelectCPxCardMutation()

  const [cpxCardInfosMap, setCpxCardInfosMap] = useState<Record<string, GetCpxHpInfosResponse>>({})
  const [isFetchingCpxCardsInfos, setIsFetchingCpxCardsInfos] = useState(false)

  const getCPxCardsInfos = useCallback(
    async (readers: CardReader[]) => {
      try {
        setIsFetchingCpxCardsInfos(true)
        for (const reader of readers) {
          const { s_status } = await selectCPxCard({ s_readerName: reader.s_name }).unwrap()
          if (s_status === 'OK') {
            const infos = await getCpxHpInfos().unwrap()
            setCpxCardInfosMap((prev) => ({ ...prev, [reader.s_name]: infos }))
          }
        }
        setIsFetchingCpxCardsInfos(false)
      } catch {
        setIsFetchingCpxCardsInfos(false)
      }
    },
    [selectCPxCard, getCpxHpInfos]
  )

  return { cpxCardInfosMap, isFetchingCpxCardsInfos, getCPxCardsInfos }
}
